<mat-list disableRipple>
  <mat-list-item
    [@snFadeIn]
    [@snFadeOut]
    *ngFor="let item of items; trackBy: trackBy"
    (click)="onItemTap(item)"
    (doubletap)="onItemDblTap(item)"
  >
    <div class="item-text">
      <div class="organization-name" [matTooltip]="item.sharerOrganization.name">
        {{ item.sharerOrganization.name }}
      </div>
      <sn-share-params [share]="item"></sn-share-params>
    </div>
    <sn-action-list alwaysCollapse [items]="actions" [context]="item"></sn-action-list>
  </mat-list-item>
</mat-list>
